var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { memo, useState, useRef, useEffect, useCallback, createElement } from '@max/max';
import { getPlatformType, isDianpingAppOrWebview } from '@nibfe/mkt-env-api';
import View from '@hfe/max-view';
import Sensor from '@max/mbc-sensor';
import CitySelectionModal from '../components/CitySelection/CitySelectionModal';
import Calendar from '../components/Calendar';
import MainFilter from '../components/MainFilter/MainFilter';
import Aicontent from '../components/AiContent';
import LImage from '@max/leez-image';
import { fetchAiAssistantData } from '../api/AiAssistantContent';
import { useSelector, useDispatch } from '@max/max-redux';
import { Actions } from '../store';
import { getActualCityId, getRequestPlatform } from '../utils/utils';
import useDebounce from '../hooks/useDebounce';
import { getUTM } from '../utils/getUTM';
import { getCityList } from '../utils/CityUtils';
import '../index.scss';
import { PlatformEnum, DianpingPlatform, AI_BUTTON_GIF_URLS, LX_CONFIG } from '../constants';
import Button from '@hfe/max-button';
import { getPredictCity, getRecommendKeywordsList, PlatformApiType } from '../api/GetDefaultCity';
import { useEngineContext } from '../hooks/useEngineContext';
const MyComponent = (p) => {
    var _a;
    const dispatch = useDispatch();
    const ctx = useEngineContext();
    const { _LXReport, _moduleId, _runtimeInfo } = ctx;
    const { commonParams = {} } = _runtimeInfo !== null && _runtimeInfo !== void 0 ? _runtimeInfo : {};
    // 从全局变量global取Context
    const platformType = getPlatformType();
    const cityInfo = useSelector(state => state.citySelection.city);
    const cityList = useSelector(state => state.citySelection.cityList);
    const cityInfos = useSelector(state => state.citySelection.cityInfos);
    const searchTextInfo = useSelector(state => state.searchText);
    const isCityInitialized = useRef(false);
    const calendarDateRange = useSelector(state => {
        var _a, _b, _c, _d;
        return ({
            endDate: (_b = (_a = state.calendar) === null || _a === void 0 ? void 0 : _a.endDate) === null || _b === void 0 ? void 0 : _b.value,
            startDate: (_d = (_c = state.calendar) === null || _c === void 0 ? void 0 : _c.startDate) === null || _d === void 0 ? void 0 : _d.value
        });
    });
    const [userInfo, setUserInfo] = useState({
        token: commonParams.token,
        uuid: commonParams.uuid,
        userId: commonParams.userId
    });
    const dispatchCity = (cities) => {
        dispatch({
            type: Actions.getCityList,
            data: cities
        });
    };
    const gifUrlIndex = useRef(0);
    const [gifUrl, setGifUrl] = useState(AI_BUTTON_GIF_URLS[0]);
    const [landmark, setLandmark] = useState('');
    const [aiAssistantData, setAiAssistantData] = useState({});
    const isDianping = DianpingPlatform.includes(platformType);
    const platformValue = isDianping ? PlatformEnum.dpApp : PlatformEnum.mtApp;
    const reqAiAssistantCommonParams = useRef({
        platform: platformValue,
        source: PlatformEnum[platformType] || PlatformEnum.mtApp
    });
    const [isOpenAiContent, setOpenAiContent] = useState(false);
    const [isContentShow, setContentShow] = useState(true);
    const queryParams = ((_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams) || {};
    const getAiAssistantData = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b, _c;
        if (!userInfo.userId || !cityInfo.value)
            return;
        const params = Object.assign(Object.assign({}, reqAiAssistantCommonParams.current), { userId: userInfo.userId, cityId: cityInfo.value, token: userInfo.token, utm_medium: getUTM(), uuid: userInfo.uuid, utm_content: userInfo.uuid, utm_campaign: isDianping ? 'Adianping-novaBdianping-novaD0H0' : 'Meituan', 
            // 决定筛选POI的城市体系
            version_name: (_c = (_b = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _b === void 0 ? void 0 : _b.commonParams) === null || _c === void 0 ? void 0 : _c.appVersion });
        Object.keys(queryParams).forEach(key => {
            if (!(key in params)) {
                params[key] = queryParams[key];
            }
        });
        const resData = (yield fetchAiAssistantData(params, ctx));
        let isFinalDisplay = false;
        if (resData === null || resData === void 0 ? void 0 : resData.aiAssistantDecisionTextModel) {
            // ai推荐文案存在情况下，判断是否展示，否则不展示
            isFinalDisplay = !!(resData === null || resData === void 0 ? void 0 : resData.isDisplay);
        }
        setAiAssistantData(resData);
        setOpenAiContent(isFinalDisplay); // isFinalDisplay为true则自动打开ai助手
        isFinalDisplay && setContentShow(isFinalDisplay); // 如果isFinalDisplay为true，则自动展开内容
    });
    const changeGifUrl = () => {
        gifUrlIndex.current = gifUrlIndex.current > 0 ? 0 : 1;
        const gifUrl = AI_BUTTON_GIF_URLS[gifUrlIndex.current];
        setGifUrl(gifUrl);
    };
    // ai开关点击事件
    const handleAiSwitchClick = useCallback(() => {
        let expand_status = isOpenAiContent;
        const { aiAssistantDecisionTextModel, isDisplay } = aiAssistantData;
        if (!p.isCommonCityChangeAndSearch && aiAssistantDecisionTextModel && isDisplay) {
            // 如果有展示内容，且可以展示，则点击ai按钮为展开和收起
            setContentShow(!isContentShow);
            expand_status = !isContentShow;
        }
        else {
            // 如果没有可展示内容，或者不可展示，则点击ai按钮为关闭和打开
            setOpenAiContent(!isOpenAiContent);
            expand_status = !isOpenAiContent;
        }
        changeGifUrl();
        _LXReport === null || _LXReport === void 0 ? void 0 : _LXReport.mcReport(LX_CONFIG.AI_BUTTON_MC_BID, {
            valLab: {
                _moduleId,
                expand_status: expand_status ? 1 : 0
            }
        });
    }, [aiAssistantData, isContentShow, isOpenAiContent]);
    // 过滤词点击事件
    const handleFilterCardClick = useCallback((landmark) => {
        _LXReport === null || _LXReport === void 0 ? void 0 : _LXReport.mcReport(LX_CONFIG.HOTSPOT_MC_BID, {
            valLab: {
                _moduleId,
                hot_spot: landmark
            }
        });
        setLandmark(landmark);
    }, []);
    const debounceChange = useDebounce(p.onChange, 0);
    const debounceCityChange = useDebounce(p.handleOnCityChange, 0);
    const getInitCityId = (cityInfos) => __awaiter(void 0, void 0, void 0, function* () {
        var _d, _e, _f;
        // 首屏默认城市信息
        let initCityInfo = getActualCityId({
            ctx,
            cityInfos
        });
        // 如果开启了预测城市，
        try {
            if (p.isPredictCity) {
                const params = {
                    cityId: initCityInfo.cityId,
                    locateCityId: (_d = commonParams === null || commonParams === void 0 ? void 0 : commonParams.cityInfo) === null || _d === void 0 ? void 0 : _d.locCityId,
                    platform: isDianpingAppOrWebview() ? PlatformApiType.dp : PlatformApiType.mt,
                    source: getRequestPlatform(),
                    userId: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId) || '',
                    token: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.token) || '',
                    utm_campaign: isDianpingAppOrWebview() ? 'Adianping-novaBdianping-novaD0H0' : 'Meituan',
                    // 决定筛选POI的城市体系
                    version_name: (_f = (_e = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _e === void 0 ? void 0 : _e.commonParams) === null || _f === void 0 ? void 0 : _f.appVersion,
                    cityStrategyType: p.cityStrategyType,
                    lng: commonParams === null || commonParams === void 0 ? void 0 : commonParams.lng,
                    lat: commonParams === null || commonParams === void 0 ? void 0 : commonParams.lat,
                    utm_medium: getUTM()
                };
                const predictCityInfo = yield getPredictCity(params, ctx);
                if (predictCityInfo === null || predictCityInfo === void 0 ? void 0 : predictCityInfo.predictCityName) {
                    const predictCityId = isDianpingAppOrWebview() ? predictCityInfo === null || predictCityInfo === void 0 ? void 0 : predictCityInfo.predictDpCityId : predictCityInfo === null || predictCityInfo === void 0 ? void 0 : predictCityInfo.predictMtCityId;
                    initCityInfo = {
                        cityId: predictCityId,
                        type: 'predict'
                    };
                }
                return {
                    cityId: initCityInfo.cityId,
                    cityName: initCityInfo.cityName
                };
            }
            else {
                return {
                    cityId: initCityInfo.cityId,
                    cityName: initCityInfo.cityName
                };
            }
        }
        catch (error) {
            return {
                cityId: initCityInfo.cityId,
                cityName: initCityInfo.cityName
            };
        }
    });
    // 前置处理，获取城市列表&用户信息
    useEffect(() => {
        var _a;
        if (!userInfo.userId || !userInfo.token) {
            if (typeof ((_a = ctx === null || ctx === void 0 ? void 0 : ctx._userAPI) === null || _a === void 0 ? void 0 : _a.forceLogin) === 'function') {
                ctx._userAPI.forceLogin().then(() => {
                    const { userId, token, uuid } = ctx._runtimeInfo.commonParams;
                    if (userId && token) {
                        setUserInfo({
                            userId,
                            token,
                            uuid
                        });
                    }
                }).catch();
            }
        }
        // 获取城市列表
        getCityList().then(cities => {
            dispatchCity && dispatchCity(cities);
        });
        return () => { };
    }, [p, ctx]);
    // 有了城市列表&用户信息后，获取初始化城市
    useEffect(() => {
        if (userInfo.userId && userInfo.token && (cityInfos === null || cityInfos === void 0 ? void 0 : cityInfos.length) > 0 && !isCityInitialized.current) {
            getInitCityId(cityInfos).then(({ cityId, cityName }) => {
                isCityInitialized.current = true;
                const stateCityInfo = {
                    value: cityId,
                    label: cityName
                };
                dispatch({
                    type: Actions.updateCitySelection,
                    data: stateCityInfo
                });
            }).catch(() => { });
        }
    }, [userInfo, cityInfos]);
    // 监听城市变化，此时必有了城市列表&用户信息
    useEffect(() => {
        var _a, _b, _c;
        setLandmark('');
        if (p.isNeedHistorySearchWord && cityInfo.value) {
            const { userId, token } = (_a = _runtimeInfo === null || _runtimeInfo === void 0 ? void 0 : _runtimeInfo.commonParams) !== null && _a !== void 0 ? _a : {};
            const locateCityId = (_c = (_b = _runtimeInfo === null || _runtimeInfo === void 0 ? void 0 : _runtimeInfo.commonParams) === null || _b === void 0 ? void 0 : _b.cityInfo) === null || _c === void 0 ? void 0 : _c.locCityId;
            getRecommendKeywordsList({
                userId,
                token,
                cityId: cityInfo.value,
                locateCityId: locateCityId,
                needHistorySearchWords: p.isNeedHistorySearchWord
            }, ctx).then(res => {
                var _a;
                if ((_a = res === null || res === void 0 ? void 0 : res.userHistorySearchWords) === null || _a === void 0 ? void 0 : _a[0]) {
                    dispatch({
                        type: Actions.UpdatePlaceholder,
                        data: res.userHistorySearchWords[0]
                    });
                }
            }).catch(error => { });
        }
        if (cityInfo.value) {
            setAiAssistantData({
                isDisplay: false,
                AIAssistantDecisionTextModel: {}
            });
            changeGifUrl();
            getAiAssistantData();
        }
    }, [cityInfo]);
    // 监听搜索词
    useEffect(() => {
        if (searchTextInfo.searchText) {
            // 如果有搜索词，清空地标
            setLandmark('');
        }
        if (searchTextInfo.searchText) {
            _LXReport === null || _LXReport === void 0 ? void 0 : _LXReport.mcReport(LX_CONFIG.QUERY_MC_BID, {
                valLab: {
                    _moduleId,
                    keyword: searchTextInfo.searchText
                }
            });
        }
    }, [searchTextInfo.searchText]);
    // 监听用户搜的地标
    useEffect(() => {
        if (landmark) {
            dispatch({
                type: Actions.UpdateSearchText,
                data: ''
            });
        }
    }, [landmark]);
    // 监听各种可能变化，通信动态poi组件
    useEffect(() => {
        if (!cityInfo.value)
            return;
        const eventParams = {
            cityId: cityInfo.value,
            searchText: searchTextInfo.searchText
        };
        if (!p.isCommonCityChangeAndSearch) {
            eventParams.checkInTimestamp = calendarDateRange.startDate;
            eventParams.checkOutTimestamp = calendarDateRange.endDate;
            eventParams.landmark = landmark;
        }
        debounceChange(eventParams);
    }, [landmark, cityInfo.value, searchTextInfo.searchText, calendarDateRange.startDate, calendarDateRange.endDate]);
    useEffect(() => {
        if (!cityInfo.value)
            return;
        debounceCityChange({
            title: cityInfo.label,
            value: String(cityInfo.value)
        });
    }, [cityInfo.value]);
    const onAiButtonShowMV = () => {
        _LXReport === null || _LXReport === void 0 ? void 0 : _LXReport.mvReport(LX_CONFIG.AI_BUTTON_MV_BID, {
            _moduleId
        });
    };
    const onAiTripPlanQueryChange = useCallback((result) => {
        if ((result === null || result === void 0 ? void 0 : result.cityId) && (result === null || result === void 0 ? void 0 : result.cityName)) {
            // 更新城市信息
            dispatch({
                type: Actions.updateCitySelection,
                data: {
                    value: Number(result.cityId),
                    label: result.cityName
                }
            });
            // 更新搜索文本
            dispatch({
                type: Actions.UpdateSearchText,
                data: result.searchText || ''
            });
        }
    }, []);
    // 监听aiTripPlanQueryChange事件
    useEffect(() => {
        var _a;
        (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.on('aiTripPlanQueryChange', onAiTripPlanQueryChange);
        return () => {
            var _a;
            (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.off('aiTripPlanQueryChange', onAiTripPlanQueryChange);
        };
    }, [onAiTripPlanQueryChange]);
    return <View className="app-mwrap" style={{
        marginTop: p.marginTop
    }}>
      
      <CitySelectionModal x-if={cityInfos.length} dispatchCity={dispatchCity} _LXReport={_LXReport} _moduleId={_moduleId} ctx={ctx} cityInfos={cityInfos}/>
      <Calendar defaultCheckDate={p.defaultCheckDate} minDays={p.minDays} fixedCheckInDate={p.fixedCheckInDate} fixedCheckOutDate={p.fixedCheckOutDate}/>
      <View className="search-wrap">
        <MainFilter {...p}/>
        
        <Sensor once onAppear={onAiButtonShowMV}>
          <Button className="ai-switch-wrap" onPress={handleAiSwitchClick}>
            <LImage className="ai-switch-icon" source={{
        uri: 'https://p0.meituan.net/ingee/b5a3b5003b35dd32bcf5db36b69d47fb19341.png'
    }} theme={{
        activeOpacity: 0.5
    }} style={{
        height: '74rpx',
        width: '68rpx'
    }} useFallback borderRadius={0}/>
          </Button>
        </Sensor>
      </View>
      
      {isOpenAiContent && <Aicontent isContentShow={isContentShow} aiAssistantData={aiAssistantData} isCommonCityChangeAndSearch={p.isCommonCityChangeAndSearch} cityName={cityInfo.label} cityId={cityInfo.value} onLandmarkClick={handleFilterCardClick} landmark={landmark}/>}
    </View>;
};
export default memo(MyComponent);
